import { 
  CheckCircle, 
  XCircle, 
  Clock as ClockIcon, 
  FileText, 
  FileImage, 
  FileSpreadsheet, 
  Archive, 
  File 
} from 'lucide-react';

// TODO: implement
export const getStatusColor = (status) => {
  const statusMap = {
    completed: "#10b981",
    disbursed: "#10b981",
    rejected: "#ef4444",
    pending: "#f59e0b",
    approved: "#3b82f6",
  };
  return statusMap[status] || "#6b7280";
};

export const getStatusIcon = (status) => {
  const statusIconMap = {
    completed: CheckCircle,
    disbursed: CheckCircle,
    rejected: XCircle,
    pending: ClockIcon,
    approved: CheckCircle,
  };
  return statusIconMap[status] || ClockIcon;
};
  
  export const getFileIcon = (format) =>  {
      const f = (format || "").toLowerCase();
      switch (f) {
        case "pdf":
          return FileText;
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return FileImage;
        case "xlsx":
        case "xls":
        case "csv":
          return FileSpreadsheet;
        case "zip":
        case "rar":
        case "7z":
          return Archive;
        default:
          return File;
      }
    };

    export const getUrgencyColor = (urgency, urgencyLevels) => {
    const level = urgencyLevels.find((l) => l.id === urgency);
    return level?.color || "#6b7280";
  };
